<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🏢</span>
            <span>Labs by Floor</span>
        </h2>
        <apexchart class="flex justify-center items-center" type="pie" width="350" :options="chartOptions"
            :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: 'LabsByFloor',
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'pie'
                },
                labels: [],
                legend: {
                    position: 'bottom',
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[opts.seriesIndex]
                    }
                },
                dataLabels: {
                    enabled: true,
                },
                colors: ['#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#7B6F9D'],
            }
        };
    },
    watch: {
        data: {
            handler(newData) {

                if (!Array.isArray(newData)) return;

                const labsByFloor = newData.reduce((acc, item) => {
                    acc[item.floor] = (acc[item.floor] || 0) + 1;
                    return acc;
                }, {});

                const labels = Object.keys(labsByFloor);
                const values = Object.values(labsByFloor);

                this.series = values;
                this.chartOptions = {
                    ...this.chartOptions,
                    labels: labels,
                    colors: this.chartOptions.colors.slice(0, labels.length),
                };
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>
